module.exports = __webpack_public_path__ + "img/i-administrator-admin.4e5c0a69.svg";